export default __webpack_public_path__ + "static/media/2024_goals.54b703ab.png";